import { useCurrentUser } from '@bonusly/who-am-i';

import { useFeedbackDraftList } from './use-feedback-draft-list';

interface FetchDraftByRecipientParams {
	recipientId: string | undefined;
}

export const useFetchDraftByRecipient = ({ recipientId }: FetchDraftByRecipientParams) => {
	const user = useCurrentUser();
	const drafts = useFeedbackDraftList({ viewUserId: user.id });

	if (!recipientId || !drafts || !drafts.draftFeedback) {
		return null;
	}

	const feedbackDraft = drafts.draftFeedback.find((draft) => draft.receiverIs(recipientId));

	return feedbackDraft;
};
